// Converts a number such as `0.4215` to `42.15%` as a string, otherwise returns original value
export const toPercent = number =>
  typeof number !== 'number' ? number : `${number * 100}%`;
